import ApeironComponent from '@/components/commons/apeiron-component.model';
import { IResultadoClasificador, Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import Component from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
import ProgramaService from '@/shared/programa/programa.service';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';

@Component
export default class ResultadoClasificadorComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public resultados: IResultadoClasificador = null;

  public mensajeClasificacion = '';

  public consultandoElBack = false;

  @Inject('programaService') protected readonly programaService: () => ProgramaService;

  public mounted(): void {
    this.resultados = this.solicitud.resultadoClasificador;
    this.validarClasificacion();
  }

  public ejecutarClasificador(): void {
    if (!this.esEscritura) {
      return;
    }
    this.consultandoElBack = true;
    this.programaService()
      .obtenerResultadoClasificador(this.solucion.id, this.solicitud.id)
      .then(
        res => {
          this.resultados = res;
          this.validarClasificacion();
          console.log(this.mensajeClasificacion);
          this.consultandoElBack = false;
        },
        err => {
          this.resultados = null;
          this.consultandoElBack = false;
        }
      );
  }

  public validarClasificacion() {
    const noExistenRubros = !this.resultados?.rubrosClasificador || this.resultados.rubrosClasificador.length === 0;
    if (noExistenRubros) {
      this.mensajeClasificacion = this.$t('apeironGwApp.programa.mensajesClasificador.resultadosNoSatisfactoriosSinRubros', {
        programa: this.solicitud.programa?.nombre || 'el programa',
      }).toString();
      return;
    }

    const rubrosNoCumplidos = this.resultados?.rubrosClasificador.filter(rubro => rubro.puntajeObtenido < rubro.puntajeMinimo) ?? [];

    const nombrePrograma = this.solicitud.programa?.nombre || 'el programa';

    if (rubrosNoCumplidos.length > 0) {
      const listaHtml = rubrosNoCumplidos.map(r => `<li>${r.descripcion}</li>`).join('');

      this.mensajeClasificacion = this.$t('apeironGwApp.programa.mensajesClasificador.resultadosNoSatisfactorios', {
        programa: nombrePrograma,
        rubros: listaHtml,
      }).toString();
    } else {
      this.mensajeClasificacion = this.$t('apeironGwApp.programa.mensajesClasificador.resultadosSatisfactorios', {
        programa: nombrePrograma,
      }).toString();
    }
  }

  get esEjecutable(): boolean {
    return this.solicitud?.cuota?.cobra != null;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    // El caso finalizada no tiene acciones posibles, se pone por validación de sintaxís de vue
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado ?? EstadoSolicitud.FINALIZADA);
  }
}
